
<template>
  <div class="project-wayline-wrapper height-100" style="position: relative;">
    <a-spin :spinning="loading" :delay="300" tip="downloading" size="large">
      <div style="height: 50px; line-height: 50px; border-bottom: 1px solid #4f4f4f; font-weight: 450;">
        <a-row>
          <a-col :span="1"></a-col>
          <a-col :span="15">Flight Route Library</a-col>
          <a-col :span="8" v-if="importVisible" class="flex-row flex-align-center">
            <a-upload
              name="file"
              :multiple="false"
              :before-upload="beforeUpload"
              :show-upload-list="false"
              :customRequest="uploadFile"
            >
              <a-button type="text" style="color: white;">
                <SelectOutlined />
              </a-button>
            </a-upload>
            <a style="color: white;" @click="showAddModal">
              <PlusOutlined />
            </a>
          </a-col>
        </a-row>
      </div>

      <!-- Tabs for Grid Planning and Waypoint Planning -->
      <div class="tabs-container">
        <div
          class="tab"
          :class="{ active: activeTab === 'waypoint' }"
          @click="activeTab = 'waypoint'"
        >
          Waypoint Planning
        </div>
        <div
          class="tab"
          :class="{ active: activeTab === 'grid' }"
          @click="activeTab = 'grid'"
        >
          Grid Planning
        </div>
      </div>

      <!-- Modal code remains the same -->
      <div
        style="
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background-color: rgba(0, 0, 0, 0.6);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          z-index: 9999;
          opacity: 1;
        "
        v-if="addModalVisible"
        @click.self="handleCancel"
      >
              <div
        style="
          background: #1c1c1c;
          border: 1px solid #333333;
          border-radius: 12px;
          width: 100%;
          max-width: 520px;
          max-height: 90vh;
          overflow: hidden;
        "
        @click.stop
      >
        <!-- Clean Header -->
        <div style="
          padding: 24px 24px 16px;
          border-bottom: 1px solid #333333;
          background: #1c1c1c;
        ">
          <div style="display: flex; align-items: center; justify-content: between;">
            <div style="display: flex; align-items: center; gap: 12px; flex: 1;">
              <div style="
                width: 36px;
                height: 36px;
                background: #2563eb;
                border-radius: 8px;
                display: flex;
                align-items: center;
                justify-content: center;
              ">
                <SendOutlined style="font-size: 16px; color: white;" />
              </div>
              <div>
                <h2 style="
                  font-size: 18px;
                  font-weight: 600;
                  color: #ffffff;
                  margin: 0;
                  line-height: 1.2;
                ">Select Flight Route</h2>
                <p style="
                  font-size: 13px;
                  color: #888888;
                  margin: 2px 0 0 0;
                  line-height: 1.3;
                ">Choose your preferred route configuration</p>
              </div>
            </div>
            <!-- <button
              @click="handleCancel"
              style="
                width: 32px;
                height: 32px;
                border-radius: 6px;
                border: 1px solid #333333;
                background: #1c1c1c;
                color: #888888;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all 0.15s ease;
              "
              @mouseover="
                event.target.style.background='#252525';
                event.target.style.color='#ffffff';
                event.target.style.borderColor='#404040';
              "
              @mouseleave="
                event.target.style.background='#1c1c1c';
                event.target.style.color='#888888';
                event.target.style.borderColor='#333333';
              "
            >
              <CloseOutlined style="font-size: 12px;" />
            </button> -->
          </div>
        </div>

        <!-- Content Area -->
        <div style="padding: 24px; background: #1c1c1c;">
          <div style="display: flex; flex-direction: column; gap: 20px;">
            <!-- Section Label -->
            <div>
              <div style="
                display: flex;
                align-items: center;
                gap: 8px;
                margin-bottom: 8px;
              ">
                <NodeIndexOutlined style="font-size: 14px; color: #2563eb;" />
                <label style="
                  font-size: 14px;
                  font-weight: 500;
                  color: #ffffff;
                ">Route Type</label>
              </div>
              <p style="
                font-size: 12px;
                color: #888888;
                margin: 0;
                line-height: 1.4;
              ">Select the flight pattern that best fits your mission requirements</p>
            </div>

            <!-- Route Options Grid -->
            <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px;">
              <button
                v-for="route in routeTypes"
                :key="route.id"
                @click="handleInputChange('routeType', route.id)"
                :style="{
                  padding: '16px 12px',
                  border: '1px solid',
                  borderRadius: '8px',
                  transition: 'all 0.15s ease',
                  borderColor: ModalState.modalForm.routeType === route.id ? '#2563eb' : '#333333',
                  background: ModalState.modalForm.routeType === route.id ? '#1e3a8a' : '#252525',
                  cursor: 'pointer',
                  outline: 'none',
                  position: 'relative',
                }"
                @mouseover="if (ModalState.modalForm.routeType !== route.id) {
                  event.target.style.background = '#2a2a2a';
                  event.target.style.borderColor = '#404040';
                }"
                @mouseleave="if (ModalState.modalForm.routeType !== route.id) {
                  event.target.style.background = '#252525';
                  event.target.style.borderColor = '#333333';
                }"
              >
                <div style="text-align: center; display: flex; flex-direction: column; gap: 8px; align-items: center;">
                  <!-- Dynamic Icons -->
                  <div style="margin-bottom: 4px;">
                    <BranchesOutlined
                      v-if="route.id === 'set-waypoints'"
                      :style="{
                        fontSize: '20px',
                        color: ModalState.modalForm.routeType === route.id ? '#ffffff' : '#2563eb'
                      }"
                    />
                    <BorderlessTableOutlined
                      v-else-if="route.id === 'mapping'"
                      :style="{
                        fontSize: '20px',
                        color: ModalState.modalForm.routeType === route.id ? '#ffffff' : '#10b981'
                      }"
                    />
                    <RadiusSettingOutlined
                      v-else-if="route.id === 'orbit'"
                      :style="{
                        fontSize: '20px',
                        color: ModalState.modalForm.routeType === route.id ? '#ffffff' : '#f59e0b'
                      }"
                    />
                    <BorderlessTableOutlined
                      v-else
                      :style="{
                        fontSize: '20px',
                        color: ModalState.modalForm.routeType === route.id ? '#ffffff' : '#8b5cf6'
                      }"
                    />
                  </div>
                  <div :style="{
                    fontWeight: '500',
                    color: ModalState.modalForm.routeType === route.id ? '#ffffff' : '#ffffff',
                    fontSize: '13px',
                  }">{{ route.name }}</div>
                  <div :style="{
                    fontSize: '11px',
                    color: ModalState.modalForm.routeType === route.id ? '#cbd5e1' : '#888888',
                    lineHeight: '1.3',
                  }">{{ route.description }}</div>
                </div>
              </button>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div style="
          padding: 20px 24px;
          border-top: 1px solid #333333;
          background: #1c1c1c;
          display: flex;
          justify-content: flex-end;
          gap: 8px;
        ">
          <button
            style="
              padding: 10px 20px;
              background: #1c1c1c;
              color: #888888;
              border: 1px solid #333333;
              border-radius: 6px;
              font-weight: 500;
              font-size: 13px;
              transition: all 0.15s ease;
              cursor: pointer;
              display: flex;
              align-items: center;
              gap: 6px;
              outline: none;
            "
            @mouseover="
              event.target.style.background='#252525';
              event.target.style.color='#ffffff';
              event.target.style.borderColor='#404040';
            "
            @mouseleave="
              event.target.style.background='#1c1c1c';
              event.target.style.color='#888888';
              event.target.style.borderColor='#333333';
            "
            @click="handleCancel"
          >
            <StopOutlined style="font-size: 12px;" />
            Cancel
          </button>
          <button
            style="
              padding: 10px 20px;
              background: #2563eb;
              color: white;
              border: none;
              border-radius: 6px;
              font-weight: 500;
              font-size: 13px;
              transition: all 0.15s ease;
              cursor: pointer;
              display: flex;
              align-items: center;
              gap: 6px;
              outline: none;
            "
            @mouseover="event.target.style.background='#1d4ed8'"
            @mouseleave="event.target.style.background='#2563eb'"
            @click="handleOK"
          >
            <CheckOutlined style="font-size: 12px;" />
            Continue
          </button>
        </div>
      </div>
      </div>

      <!-- Content area with filtered waylines -->
      <div :style="{ height: contentHeight + 'px'}" class="scrollbar">
        <div id="data" class="height-100 uranus-scrollbar" v-if="filteredWaylines.length !== 0" @scroll="onScroll">
          <div v-for="wayline in filteredWaylines" :key="wayline.id">
            <div class="wayline-panel" style="padding-top: 5px;" @click="selectRoute(wayline)">
              <div class="title">
                <a-tooltip :title="wayline.name">
                  <div class="pr10" style="width: 120px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">{{ wayline.name }}</div>
                </a-tooltip>
                <div class="ml10"><UserOutlined /></div>
                <a-tooltip :title="wayline.user_name">
                  <div class="ml5 pr10" style="width: 80px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">{{ wayline.user_name }}</div>
                </a-tooltip>
                <div class="fz20">
                  <a-dropdown>
                    <a style="color: white;">
                      <EllipsisOutlined />
                    </a>
                    <template #overlay>
                      <a-menu theme="dark" class="more" style="background: #3c3c3c;">
                        <a-menu-item @click="downloadWayline(wayline.id, wayline.name)">
                          <span>Download</span>
                        </a-menu-item>
                                               <a-menu-item @click="selectRoute(wayline, isEdit= true)">
                          <span>Edit</span>
                        </a-menu-item>
                        <a-menu-item @click="showWaylineTip(wayline.id)">
                          <span>Delete</span>
                        </a-menu-item>

                      </a-menu>
                    </template>
                  </a-dropdown>
                </div>
              </div>
              <div class="ml10 mt5" style="color: hsla(0,0%,100%,0.65);">
                <span><RocketOutlined /></span>
                <span class="ml5">{{ DEVICE_NAME[wayline.drone_model_key] }}</span>
                <span class="ml10"><CameraFilled style="border-top: 1px solid; padding-top: -3px;" /></span>
                <span class="ml5" v-for="payLoad in wayline.payLoad_model_keys" :key="payLoad.id">
                  {{ DEVICE_NAME[payLoad] }}
                </span>
              </div>
              <div class="mt5 ml10" style="color: hsla(0,0%,100%,0.35);">
                <span class="mr10">Update at {{ new Date(wayline.update_time).toLocaleString() }}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <a-empty :image-style="{ height: '60px', marginTop: '60px' }" />
        </div>
        <a-modal v-model:visible="deleteTip" width="450px" :closable="false" :maskClosable="false" centered :okButtonProps="{ danger: true }" @ok="deleteWayline">
          <p class="pt10 pl20" style="height: 50px;">Wayline file is unrecoverable once deleted. Continue?</p>
          <template #title>
            <div class="flex-row flex-justify-center">
              <span>Delete</span>
            </div>
          </template>
        </a-modal>
      </div>
    </a-spin>
  </div>
</template>

<script lang="ts" setup>
// Import all Vue reactivity functions at the top
import { reactive, ref, onMounted, computed, onUpdated } from 'vue'
import { message } from 'ant-design-vue'
import { deleteWaylineFile, downloadWaylineFile, getWaylineFiles, importKmzFile } from '/@/api/wayline'
import { ELocalStorageKey, ERouterName } from '/@/types'
import {
  EllipsisOutlined,
  RocketOutlined,
  CameraFilled,
  UserOutlined,
  SelectOutlined,
  PlusOutlined,
  AimOutlined,
  DeploymentUnitOutlined,
  RadiusSettingOutlined,
  SendOutlined,
  StopOutlined,
  CheckOutlined,
  CloseOutlined,
  NodeIndexOutlined,
  BorderlessTableOutlined,
  BranchesOutlined
} from '@ant-design/icons-vue'
import { DEVICE_NAME } from '/@/types/device'
import { useMyStore } from '/@/store'
import { WaylineFile } from '/@/types/wayline'
import { downloadFile } from '/@/utils/common'
import { IPage } from '/@/api/http/type'
import { CURRENT_CONFIG } from '/@/api/http/config'
import { getRoot } from '/@/root'
import { useFlightRouteModalState } from '/@/piniastore/flightRouteModalState.js'
import { useRouter } from 'vue-router'
import axios from 'axios'
import { useWaylineState } from '../../../piniastore/waylineState'
import { useSetWaypointsState } from '../../../piniastore/setWaypointsState'
import { useMapState } from '../../../piniastore/mapState'
import { useflightPlanState } from '../../../piniastore/flightPlanState'
import { usePolygonState } from '../../../piniastore/polygonState'
import { useGMapManage } from '../../../hooks/use-g-map'

const loading = ref(false)
const store = useMyStore()
const waylineState = useWaylineState()
const ModalState = useFlightRouteModalState()

const pagination: IPage = {
  page: 1,
  total: -1,
  page_size: 10
}

const waylinesData = reactive({
  data: [] as WaylineFile[]
})

const root = getRoot()
const workspaceId = localStorage.getItem(ELocalStorageKey.WorkspaceId)!
const deleteTip = ref(false)
const deleteWaylineId = ref<string>('')
const canRefresh = ref(true)
const importVisible = ref<boolean>(root.$router.currentRoute.value.name === ERouterName.WAYLINE)
const contentHeight = ref(0)
const isEditclicked = ref(false)
const mapState = useMapState()
const useGMapManageHook = useGMapManage()
// Add reactive state for active tab
const activeTab = ref<'waypoint' | 'grid'>('waypoint')

// Computed property to filter waylines based on active tab
const filteredWaylines = computed(() => {
  return waylinesData.data.filter(wayline => {
    // Check if template_types exists and has at least one value
    if (wayline.template_types && wayline.template_types.length > 0) {
      const templateType = wayline.template_types[0]
      // 0 = Waypoint Planning, 1 = Grid Planning
      return (activeTab.value === 'waypoint' && templateType === 0) ||
             (activeTab.value === 'grid' && templateType === 1)
    }
    // If no template_types, default to waypoint planning
    return activeTab.value === 'waypoint'
  })
})

onMounted(() => {
  const parent = document.getElementsByClassName('scrollbar').item(0)?.parentNode as HTMLDivElement
  // Adjust height to account for tabs
  contentHeight.value = document.body.clientHeight - parent?.firstElementChild!.clientHeight - 40 // 40px for tabs
  getWaylines()

  const key = setInterval(() => {
    const data = document.getElementById('data')?.lastElementChild as HTMLDivElement
    if (pagination.total === 0 || Math.ceil(pagination.total / pagination.page_size) <= pagination.page || contentHeight.value <= data?.clientHeight + data?.offsetTop) {
      clearInterval(key)
      return
    }
    pagination.page++
    getWaylines()
  }, 1000)
})

function getWaylines () {
  if (!canRefresh.value) {
    return
  }
  canRefresh.value = false
  getWaylineFiles(workspaceId, {
    page: pagination.page,
    page_size: pagination.page_size,
    order_by: 'update_time desc'
  }).then(res => {
    if (res.code !== 0) {
      return
    }
    waylinesData.data = [...waylinesData.data, ...res.data.list]
    pagination.total = res.data.pagination.total
    pagination.page = res.data.pagination.page
  }).finally(() => {
    canRefresh.value = true
    console.log('waylinesData:', waylinesData.data)
  })
}

function showWaylineTip (waylineId: string) {
  deleteWaylineId.value = waylineId
  deleteTip.value = true
}

function handleWaypointOption (option) {
  console.log('Selected Waypoint Option:', option)
  router.push('/set-waypoints')
  this.waypointModalVisible = false
}

function deleteWayline () {
  deleteWaylineFile(workspaceId, deleteWaylineId.value).then(res => {
    if (res.code === 0) {
      message.success('Wayline file deleted')
    }
    useGMapManageHook.clearAllMapLayersonWayline()
    deleteWaylineId.value = ''
    deleteTip.value = false
    pagination.total = 0
    pagination.page = 1
    waylinesData.data = []
    getWaylines()
  })
}

const addModalVisible = ref(false)
const waypointModalVisible = ref(false)

function showAddModal () {
  addModalVisible.value = !addModalVisible.value
}
function showWaypointModal () {
  waypointModalVisible.value = !waypointModalVisible.value
}

const routeTypes = [
  { id: 'set-waypoints', name: 'Waypoint', icon: '🏠', description: 'Within country borders' },
  { id: 'area-route', name: 'Area', icon: '🌍', description: 'Cross-border flights' },
  // { id: 'regional', name: 'Regional', icon: '🗺️', description: 'Short-haul regional' }
]

const handleInputChange = (field: 'routeName' | 'airCraft' | 'payLoad' | 'routeType', value: string) => {
  ModalState.modalForm[field] = value // ✅ update global state
  // if (value === 'waypoint') {
  //   console.log('waypoint selected!!')
  //   showWaypointModal()
  // }
}
const router = useRouter()
const setWaypointState = useSetWaypointsState()
const handleOK = () => {
  console.log('🔄 Navigating to new planning, clearing previous data')

  // Clear wayline state
  waylineState.setWayline(null)
  waylineState.setEditWaylineData(null)
  waylineState.setEditMode(false)

  // Clear polygon state
  const polygonState = usePolygonState()
  polygonState.setIsFormed(false)
  polygonState.setGeoJsonPolygon(null)

  // Clear flight plan state
  const flightPlanState = useflightPlanState()
  flightPlanState.setFlightPlan(null)

  console.log('state response:', ModalState.modalForm)
  addModalVisible.value = false

  if (ModalState.modalForm.routeType === 'set-waypoints') {
    console.log('handleOK for setwaypoint')
    setWaypointState.resetForNewPlanning()
    router.push('/set-waypoints')
  } else {
    router.push({ name: `${ModalState.modalForm.routeType}` })
  }
}

const handleCancel = () => {
  addModalVisible.value = false
}

function downloadWayline (waylineId: string, fileName: string) {
  loading.value = true
  downloadWaylineFile(workspaceId, waylineId).then(res => {
    if (!res) {
      return
    }
    const data = new Blob([res], { type: 'application/zip' })
    downloadFile(data, fileName + '.kmz')
  }).finally(() => {
    loading.value = false
  })
}

// async function selectRoute (wayline: WaylineFile) {
//   console.log('wayline info:', JSON.parse(JSON.stringify(wayline)))
//   store.commit('SET_SELECT_WAYLINE_INFO', wayline)
//   const wayline_id = JSON.parse(JSON.stringify(wayline)).id
//   try {
//     const response = await axios.get(`https://demoapi.hellogeo.world/wayline/json?workspaceId=${localStorage.getItem('workspace_id')}&waylineId=${wayline_id}`, {
//       headers: {
//         'x-auth-token': localStorage.getItem('x-auth-token')
//       }
//     })
//     console.log('API of wayline response:', response.data)
//     waylineState.setWayline(response.data)
//     waylineState.setUserName(JSON.parse(JSON.stringify(wayline)).user_name)
//   } catch (error) {
//     console.error('Error fetching wayline details:', error)
//   }
// }

// async function selectRoute (wayline: WaylineFile, isEdit: boolean = false) {
//   console.log('wayline info:', JSON.parse(JSON.stringify(wayline)))

//   // FIX: Check if store and commit method exist
//   if (store && typeof store.commit === 'function') {
//     store.commit('SET_SELECT_WAYLINE_INFO', wayline)
//   } else {
//     console.warn('Store or commit method not available')
//   }

//   const wayline_id = JSON.parse(JSON.stringify(wayline)).id
//   waylineState.deleteId = wayline_id

//   try {
//     const response = await axios.get(`https://demoapi.hellogeo.world/wayline/json?workspaceId=${localStorage.getItem('workspace_id')}&waylineId=${wayline_id}`, {
//       headers: {
//         'x-auth-token': localStorage.getItem('x-auth-token')
//       }
//     })
//     console.log('API of wayline response:', response.data)

//     // Set the wayline data in both stores
//     const waylineState = useWaylineState()
//     const setWaypointState = useSetWaypointsState()

//     waylineState.setWayline(response.data)
//     waylineState.setUserName(JSON.parse(JSON.stringify(wayline)).user_name)

//     // Parse the wayline data for editing
//     setWaypointState.parseWaylineData(response.data)

//     // Navigate to the waypoint planning page with edit mode
//     if (isEdit === true && wayline.template_types[0] === 0) {
//       router.push('/set-waypoints')
//     } else if (isEdit === true && wayline.template_types[0] === 1) {
//       router.push('/area-route')
//     }
//   } catch (error) {
//     console.error('Error fetching wayline details:', error)
//   }
// }

async function selectRoute (wayline: WaylineFile, isEdit: boolean = false) {
  console.log('wayline info:', JSON.parse(JSON.stringify(wayline)))

  // FIX: Check if store and commit method exist
  if (store && typeof store.commit === 'function') {
    store.commit('SET_SELECT_WAYLINE_INFO', wayline)
  } else {
    console.warn('Store or commit method not available')
  }

  const wayline_id = JSON.parse(JSON.stringify(wayline)).id
  waylineState.deleteId = wayline_id
  waylineState.filename = JSON.parse(JSON.stringify(wayline)).name

  try {
    const response = await axios.get(`https://demoapi.hellogeo.world/wayline/json?workspaceId=${localStorage.getItem('workspace_id')}&waylineId=${wayline_id}`, {
      headers: {
        'x-auth-token': localStorage.getItem('x-auth-token')
      }
    })
    console.log('API of wayline response:', response.data)

    // Set the wayline data in both stores
    const waylineState = useWaylineState()
    const setWaypointState = useSetWaypointsState()

    waylineState.setWayline(response.data)
    waylineState.setUserName(JSON.parse(JSON.stringify(wayline)).user_name)

    // Set edit mode
    waylineState.setEditMode(isEdit)
    waylineState.setEditWaylineData(response.data)

    // Navigate to the appropriate page based on template type
    if (isEdit) {
      const templateType = wayline.template_types && wayline.template_types.length > 0 ? wayline.template_types[0] : 0

      if (templateType === 0) {
        // Waypoint Planning
        setWaypointState.parseWaylineData(response.data)
        router.push('/set-waypoints')
      } else if (templateType === 1) {
        // Grid Planning
        router.push('/area-route')
      }
    }
  } catch (error) {
    console.error('Error fetching wayline details:', error)
  }
}

function onScroll (e: any) {
  const element = e.srcElement
  if (element.scrollTop + element.clientHeight >= element.scrollHeight - 5 && Math.ceil(pagination.total / pagination.page_size) > pagination.page && canRefresh.value) {
    pagination.page++
    getWaylines()
  }
}

interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: string;
  url?: string;
}

interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}
const fileList = ref<FileItem[]>([])

function beforeUpload (file: FileItem) {
  fileList.value = [file]
  loading.value = true
  return true
}
const uploadFile = async () => {
  fileList.value.forEach(async (file: FileItem) => {
    const fileData = new FormData()
    fileData.append('file', file, file.name)
    await importKmzFile(workspaceId, fileData).then((res) => {
      if (res.code === 0) {
        message.success(`${file.name} file uploaded successfully`)
        canRefresh.value = true
        pagination.total = 0
        pagination.page = 1
        waylinesData.data = []
        getWaylines()
      }
    }).finally(() => {
      loading.value = false
      fileList.value = []
    })
  })
}
</script>

<style lang="scss" scoped>
// Add styles for tabs
.tabs-container {
  display: flex;
  border-bottom: 1px solid #4f4f4f;
  height: 40px;
  background: #2c2c2c;

  .tab {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: hsla(0,0%,100%,0.65);
    font-weight: 500;
    transition: all 0.2s ease;

    &:hover {
      background: #3a3a3a;
      color: #ffffff;
    }

    &.active {
      background: #1c1c1c;
      color: #ffffff;
      border-bottom: 2px solid #1890ff;
    }
  }
}

.wayline-panel {
  background: #3c3c3c;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  height: 90px;
  width: 95%;
  font-size: 13px;
  border-radius: 2px;
  cursor: pointer;

  .title {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 30px;
    font-weight: bold;
    margin: 0px 10px 0 10px;
  }
}

.uranus-scrollbar {
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: #c5c8cc transparent;
}
</style>
